import { ChangeEventHandler, FC } from 'react'
import { OrganizerFilterComponentDto } from '~/modules/Organizers/Infrastructure/OrganizerFilterComponentDto'
import styles from './OrganizerFilter.module.scss'
import { useTranslation } from 'next-i18next'
import { UiAppearance } from '~/modules/UiVariant/appearance'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronDown, faSliders } from '@fortawesome/free-solid-svg-icons'

interface Props {
  organizers: OrganizerFilterComponentDto[]
  organizerId: string | null
  setOrganizerId: ChangeEventHandler<HTMLSelectElement>
  appearance?: UiAppearance
}

export const OrganizerFilter: FC<Props> = ({ organizers, organizerId, setOrganizerId, appearance = 'default' }) => {
  const { t } = useTranslation('filters')
  const organizerOptions = organizers
    .map((organizer) => (
      <option value={ organizer.id } key={ organizer.id }>
        { organizer.name }
      </option>
    ))

  const selectedOrganizer = organizers.find((organizer) => organizer.id === organizerId)
  let defaultValue: string | undefined

  if (selectedOrganizer) {
    defaultValue = selectedOrganizer.id
  }

  if (appearance === 'museumHome') {
    return (
      <div className={ styles.organizerFilter__control }>
        <FontAwesomeIcon
          icon={ faSliders }
          className={ styles.organizerFilter__icon }
        />

        <select
          data-qa='organizer-filter'
          className={ styles.organizerFilter__container_museumHome }
          onChange={ setOrganizerId }
          value={ defaultValue ?? '' }
          aria-label={ t('filter_by_organizer_placeholder') }
        >
          <option value={ '' }>{ t('market_filter_label', { defaultValue: 'Filter' }) }</option>
          { organizerOptions }
        </select>

        <FontAwesomeIcon
          icon={ faChevronDown }
          className={ styles.organizerFilter__chevron }
        />
      </div>
    )
  }

  return (
    <select
      data-qa='organizer-filter'
      className={ styles.organizerFilter__container }
      onChange={ setOrganizerId }
      value={ defaultValue ?? '' }
    >
      <option value={ '' }>{ t('filter_by_organizer_placeholder') }</option>
      { organizerOptions }
    </select>
  )
}
